//Dropdown constants
export const FERRY_FLIGHT = "ferry flight";
export const FIELD_TRIP = "field trip";